export enum ScoringAndCoachingTabs {
  SCORECARDS = 'scorecards',
  COACHING_RUBRICS = 'coaching-rubrics',
}

export enum TemplateStatus {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
}
